/**
 * Where an appointment came from — `Appointment.source`, scheduling's word, carried
 * as-is by the clinic BFF and on the realtime frame.
 *
 *   desk | phone | api | store | doctor_app      — the clinic or a practitioner booked it
 *   patient_app | doctor_page                    — the PATIENT booked it themselves
 *
 * The second pair is «آنلاین» on the reception row and the «نوبت آنلاین جدید» toast
 * (PM-0382, docs/DOCTOR_PAGE_INSTANT_BOOKING_PLAN.md §4.8). Since 2026-10-19 such a
 * booking is always confirmed, so this is the desk's only cue that nobody at the
 * clinic made it. One set, here, for both — a second copy is how the chip and the
 * toast would come to disagree about one row.
 *
 * The LABELS are not here (the panel is multilingual): `reception.online.*`.
 */
export const ONLINE_SOURCES = Object.freeze(['patient_app', 'doctor_page']);

/** True for a booking the patient made themselves — the patient app or the doctor's page. */
export function isOnlineSource(source) {
  return ONLINE_SOURCES.includes(String(source || '').trim().toLowerCase());
}

/** The catalogue key that says, in a sentence, WHERE an online booking came from. */
export function onlineSourceHintKey(source) {
  const s = String(source || '').trim().toLowerCase();
  if (s === 'doctor_page') return 'reception.online.fromDoctorPage';
  if (s === 'patient_app') return 'reception.online.fromPatientApp';
  return null;
}
